import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { IGeneratePrimaryTermsRequest, TFeePaymentType } from '../../models/registration.model';

interface ILoanCalculation extends IGeneratePrimaryTermsRequest {
    installmentAmount: number,
    financialSupplierTitle: string,
}

const initialState: ILoanCalculation  = {
    financialSupplier: '',
    loanAmount: 0,
    loanTemplateId: 0,
    organizationId: 0,
    stepSpaceId: 0,
    installmentAmount: 0,
    financialSupplierTitle: '',
};

export const calulationResultSlice = createSlice({
    name: 'calulationResult',
    initialState,
    reducers: {
        setLoanCalculationResult: (state, action: PayloadAction<ILoanCalculation>) => {
            return action.payload
        },
    },
});

export const {setLoanCalculationResult}: any = calulationResultSlice.actions;

export default calulationResultSlice.reducer;
